"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadycableCategorySchema = void 0;
const zod_1 = require("zod");
exports.ReadycableCategorySchema = zod_1.z.enum(['DriveTech', 'NetTech', 'SensorActor', 'VideoVisionBus', 'HartingIndustrialConnectors', 'RcRobotic']);
exports.default = exports.ReadycableCategorySchema;
//# sourceMappingURL=ReadycableCategorySchema.js.map